import { ChangeDetectorRef, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppClientContext } from 'src/app-client/_appCommon/base/AppClientContext';
import { CARDMONTHS } from 'src/app-client/_appCommon/base/Constants';
import { CaseDataService } from 'src/app-client/_dataservices/CaseDataService';
import { ControllerBase } from 'src/app-client/_appCommon/base/ControllerBase';
import { CustomerDataService } from 'src/app-client/_dataservices/CustomerDataService';
import { OpenpayService } from 'src/app-client/_dataservices/security/OpenpayService';
import { OrderDataService } from 'src/app-client/_dataservices/OrderDataService';
import { PaymentPlanDescription, PaymentPlan } from '../../../../app/_appCommon/base/AppInterfaceAndBaseClasses';
import { PaymentType } from 'src/app/_appCommon/base/AppInterfaceAndBaseClasses';
import { OpenPayCardObject, OrderPaymentStatus, ProductDetail, Service, ServiceType, ShoppingCartItem } from 'src/app-client/_appCommon/base/AppInterfaceAndBaseClasses';
import { ShoppingCartDataService } from 'src/app-client/_dataservices/ShoppingCartDataService';
import { CasePurchasedOrdersDataService } from 'src/app-client/_dataservices/CasePurchasedOrdersDataService';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { SystemConfigDataService } from '../../../_dataservices/SystemConfigDataService';

@Component({
  selector: 'app-openpay-form',
  templateUrl: './openpay-form.component.html',
  styleUrls: ['./openpay-form.component.css'],
  providers: [CaseDataService, CustomerDataService, OpenpayService, OrderDataService,CasePurchasedOrdersDataService, SystemConfigDataService],
  encapsulation: ViewEncapsulation.None
})
export class OpenpayFormComponent extends ControllerBase
{
  @ViewChild('theForm') public _form: NgForm;

  public cardObject: OpenPayCardObject = {
    holderName: "",
    holderEmail: "",
    cardNumber: null,
    cvv2: null,
    expirationMonth: null,
    expirationYear: null,
    deviceSessionId: null
  };

  public cardMonths = CARDMONTHS;
  public chargeObject: any;
  public currentCart: ShoppingCartItem[];
  public currentCustomer: any;
  public isLoading: boolean = false;
  public openPayPaymentPlanArray: any[] = [];
  public paymentPlanSelected: PaymentPlan;
  public purchaseCode: any = "";
  public orderId: number;
  public currentOrder: any;
  public orderDetailFirstServiceType : any;
  public isPendingPayment: boolean = false;
  PaymentPlan = PaymentPlan;
  percentageForMSIUsage: number = 0;
  percentagsForMSIUsageSystemConfig:any;

  constructor(
    private caseDataService: CaseDataService,
    private customerDataService: CustomerDataService,
    private openPayService: OpenpayService,
    private orderDataService: OrderDataService,
    private casePurchasedOrderDataService: CasePurchasedOrdersDataService,
    private router: Router,
    private shoppingCartDataService: ShoppingCartDataService,
    private cdr: ChangeDetectorRef,
    public activatedRoute:ActivatedRoute,
    private systemConfigDataService:SystemConfigDataService
  )
  {
    super();
    this.shoppingCartDataService.setPercentageForMSIUsage(0);

    this.systemConfigDataService.getSystemConfigPercentageMSIValues().subscribe(res=>{
      this.percentagsForMSIUsageSystemConfig = res;
    })


    this.shoppingCartDataService.getPercentageForMSIUsage().subscribe(res=>{
      this.percentageForMSIUsage = res;
    })
  }

  ngOnInit(): void
  {
    this.shoppingCartDataService.getItems()
      .subscribe(cart =>
      {
        this.currentCart = cart;
      });

    //DisabledPaymentPlanDescription
    this.openPayPaymentPlanArray = [];
    /*let paymentPlan = {
      value: PaymentPlan.SinglePayment,
      label: "Pago único",
    }*/
    //this.openPayPaymentPlanArray.push(paymentPlan);

    this.cdr.detectChanges();

    PaymentPlanDescription.forEach((value, key) =>
    {
      if(key != PaymentPlan.TwelveMonths){
        let paymentPlan = {
          value: key,
          label: value,
        };
  
        this.openPayPaymentPlanArray.push(paymentPlan);
      }
    });

    this.shoppingCartDataService.isCompleteCreateAddedServices$
    .subscribe(response => {
      if(response){
        this.updateCaseProductId(this.orderDetailFirstServiceType.id, this.orderDetailFirstServiceType.orderId);
        this.isLoading = false;
        this.router.navigate(['ecommerce/compra-completada', { Code: this.purchaseCode }]);
        this.shoppingCartDataService.setIsCompleteCreateAddedServices(false);
      }
      
    });
  }

  ngAfterViewInit(): void
  {
    this.activatedRoute.queryParamMap.subscribe(params => {
      setTimeout(() => {
        this.orderId = +params.get('orderId');
        if(this.orderId != 0)
        {
          this.isPendingPayment = true; 
           this.orderDataService.getById(this.orderId, this.onGetQueryDefForGetById())
          .subscribe((response) => {
            this.currentOrder = response;
            this.getCustomerInfo();
          });
         
        }
        else
        {
          this.getCustomerInfo();
        }

      });
    });
  }

  private getCustomerInfo()
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id)
        .subscribe((customerResponse: any) =>
        {
          this.currentCustomer = customerResponse.items.firstOrNull();

          if (this.currentCustomer)
          {
            AppClientContext.Instance.customerId = this.currentCustomer.id;
            this.setCustomerInformation(this.currentCustomer);
          }
          else
          {
            this.router.navigate(["/ecommerce"]);
          }
        });
    }
    else
    {
      this.router.navigate(["/ecommerce"]);
    }
  }

  public setCustomerInformation(currentCustomer: any): void
  {
    this.cardObject.holderName = this.currentCustomer.fullName;
    this.cardObject.holderEmail = this.currentCustomer.email;
  }

  public onClickPay()
  {
    if (this._form.valid)
    {
      this.isLoading = true;

      this.openPayService.generateToken(this.cardObject)
        .subscribe((cardToken) =>
        {
          this.onGenerateCardToken(cardToken);
        }, (fail) =>
        {
          this.setDangerAlert("Error: " + fail.message);
          this.isLoading = false;
        });
    }
  }

  private onGenerateCardToken(cardToken: any)
  {
    this.getChargeObject(cardToken.id);

    this.openPayService.charge(this.chargeObject)
      .subscribe((chargeRes) =>
      {
        this.onCompleteCharge(chargeRes);
      }, (chargeError) =>
      {
        this.setDangerAlert("Error: " + chargeError.message);
        this.isLoading = false;
      });
  }

  private onCompleteCharge(chargeRes: any)
  {
    if (chargeRes.status === "completed")
    {
     
      this.setSuccessAlert("Operación completada con éxito");
      if(this.isPendingPayment){
        this.doPendingPayment(chargeRes.description);
      }
      else
      {
        this.onSuccesfullPurchase(chargeRes.description,chargeRes.id, chargeRes.status);
      }
    }
    else
    {
      const httpErrorCode: number = chargeRes.http_code;
      const openpayErrorCode: number = chargeRes.error_code;
      const errorMessage: string = this.getOpenpayErrorMessage(httpErrorCode, openpayErrorCode);
      this.setDangerAlert("Error: " + errorMessage);
      this.isLoading = false;
    }
  }

  private onSuccesfullPurchase(responseDescription: string, transactionId: string ,status : any)
  {

    this.postOrder(responseDescription, transactionId,status);
  }

  private postOrder(responseDescription: string, transactionId:string ,status : any)
  {
    this.orderDetailFirstServiceType = null;
    this.purchaseCode = responseDescription;
    const orderBody: any = {
      "Comments": "Compra: " + responseDescription + " en Aliwell via OpenPay",
      "PaymentType": PaymentType.OpenPay,
      "PaymentTransactionId": transactionId,
      "CustomerId": this.currentCustomer.id,
      "CouponId": null,
      "ProductDetailList": this.getOrderDetailList(),
      "PaymentStatus": status,
      "Code": this.purchaseCode,
      "PercentageAmountForMSIUsage": this.percentageForMSIUsage,
      "FinancingMonths": this.getFinancingMonths(),
      "CaseId": this.shoppingCartDataService.caseId
    };

    this.orderDataService.createOrder(orderBody)
      .subscribe((res) =>
      {
        if (this.shoppingCartDataService.caseId !== null && !this.shoppingCartDataService.currentCartHasService())
        {
          this.addCasePurchasedOrders(this.shoppingCartDataService.caseId, res.id, res.orderDetail[0].id);
          this.updateCaseProductId(res.orderDetail[0].id, res.orderDetail[0].orderId);
        }
        else if (this.shoppingCartDataService.caseId !== null && !this.shoppingCartDataService.isProduct(this.shoppingCartDataService.currentShoppingCart[0].item))
        {
          this.addCasePurchasedOrders(this.shoppingCartDataService.caseId, res.id, res.orderDetail[0].id);
          let temporalService: Service = this.shoppingCartDataService.currentShoppingCart[0].item as Service;
          if (temporalService.serviceType == ServiceType.Upgrade)
          {
            this.onUpgradeProduct(temporalService.serviceProductUpgrade.id, res.orderDetail[0].id);
          }
          else
          {
            this.shoppingCartDataService.lastOrderId = res.id;
            this.orderDetailFirstServiceType = res.orderDetail[0];
            //Service in ShoppingCart
            if (this.currentCart.length > 0 && this.shoppingCartDataService.currentCartHasService)
            {
              this.shoppingCartDataService.onChargeDoneServices();
            }
          }
        }
        else
        {
          this.isLoading = false;
          this.router.navigate(['ecommerce/compra-completada', { Code: this.purchaseCode }]);
        }
      }, (error) =>
      {
        this.setDangerAlert(error.message);
        this.isLoading = false;
      });
  }

  private getOrderDetailList(): ProductDetail[]
  {
    let productDetailList: ProductDetail[] = [];

    this.currentCart.forEach(item =>
    {
      //Define two paths
      let pd: ProductDetail;
      if (this.shoppingCartDataService.isProduct(item.item))
      {
        //Product
        pd =
        {
          productId: item.item.id,
          quantity: item.quantity,
          quantityExtraAligners: item.item.additionalServices.extraAlignersQuantity ?? 0,
          addDentalMonitoring: item.item.additionalServices.addDentalMonitoring ?? false,
          addIsComplexCase: item.item.additionalServices.addIsComplexCase ?? false,
          caseId: this.shoppingCartDataService.caseId ? this.shoppingCartDataService.caseId : null,
          isService: false
        };
      }
      else
      {
        let serviceItem: Service = item.item as Service;
        //Service
        pd =
        {
          productId: serviceItem.id,
          quantity: 1,
          quantityExtraAligners: serviceItem.additionalServices.extraAlignersQuantity ?? 0,
          addDentalMonitoring: serviceItem.additionalServices.addDentalMonitoring ?? false,
          addIsComplexCase: serviceItem.additionalServices.addIsComplexCase ?? false,
          caseId: this.shoppingCartDataService.caseId ? this.shoppingCartDataService.caseId : null,
          isService: true,
          serviceType: serviceItem.serviceType,
        };
        if (item.item.serviceType == ServiceType.Upgrade)
        {
          pd.newProductUpgradeId = item.item.serviceProductUpgrade.id;
          pd.orderDetailId = item.item.serviceProductUpgrade.orderDetailId;
        }
      }
      productDetailList.push(pd);
    });
    return productDetailList;
  }

  private updateCaseProductId(orderDetailId: number, orderId:number)
  {
    const body: any = {
      "caseId": this.shoppingCartDataService.caseId,
      "productId": this.currentCart[0].item.id,
      "orderDetailId": orderDetailId,
      "orderId": orderId,
    };

    this.caseDataService.updateProductId(body)
      .subscribe((res) =>
      {
        this.setSuccessAlert("Producto asignado al caso");
        this.isLoading = false;
        this.shoppingCartDataService.onClearItems();
        this.router.navigate(['ecommerce/compra-completada', { Code: this.purchaseCode }]);
      }, (error) =>
      {
        this.setDangerAlert(error.message);
        this.isLoading = false;
      });
  }

  private getChargeObject(cardTokenId: string)
  {
    this.chargeObject = {
      "Method": "card",
      "SourceId": cardTokenId,
      "Amount": this.getTotal,
      "Description": "Cargo nuevo",
      "DeviceSessionId": "0123456789",
      "CustomerName": this.cardObject.holderName,
      "CustomerEmail": this.cardObject.holderEmail,
      "PaymentPlan": this.paymentPlanSelected
    };
  }

  public get getTotal(): string
  {
    return !this.isPendingPayment ? ((+this.shoppingCartDataService.getTotal() ?? 0) + this.percentageForMSIUsage).toFixed(2) : this.currentOrder != undefined ? (+this.currentOrder?.orderDetail[0]?.total + this.percentageForMSIUsage).toFixed(2) :'0.00';
  }

  public get getTotalWOMSI(){
    return !this.isPendingPayment ? (+this.shoppingCartDataService.getTotal() ?? 0).toFixed(2) : this.currentOrder != undefined ? (+this.currentOrder?.orderDetail[0]?.total).toFixed(2) : '0.00';
  }

  public onCardNumberChange(cardNumber:string): void
  {
    this.cardObject.cardNumber = cardNumber;
  }

  private getOpenpayErrorMessage(httpErrorCode: number, openpayErrorCode: number): string
  {
    let errorMessage: string = "Unknown error";
    if (openpayErrorCode === 1000 && httpErrorCode === 500)
    {
      errorMessage = "Ocurrió un error interno en el servidor de Openpay";
    }
    else if (openpayErrorCode === 1001 && httpErrorCode === 400)
    {
      errorMessage = "Verifique su información, ha ocurrido un error";
    }
    else if (openpayErrorCode === 1002 && httpErrorCode === 401)
    {
      errorMessage = "La llamada no está autentificada o la autentificación es incorrecta";
    }
    else if (openpayErrorCode === 1003 && httpErrorCode === 422)
    {
      errorMessage = "La operación no se pudo completar por que el valor de uno o más de los parámetros no es correcto";
    }
    else if (openpayErrorCode === 1004 && httpErrorCode === 503)
    {
      errorMessage = "Un servicio necesario para el procesamiento de la transacción no se encuentra disponible";
    }
    else if (openpayErrorCode === 1005 && httpErrorCode === 404)
    {
      errorMessage = "Uno de los recursos requeridos no existe";
    }
    else if (openpayErrorCode === 1006 && httpErrorCode === 409)
    {
      errorMessage = "Ya existe una transacción con el mismo ID de orden";
    }
    else if (openpayErrorCode === 1007 && httpErrorCode === 402)
    {
      errorMessage = "La transferencia de fondos entre una cuenta de banco o tarjeta y la cuenta de Openpay no fue aceptada";
    }
    else if (openpayErrorCode === 1008 && httpErrorCode === 423)
    {
      errorMessage = "Una de las cuentas requeridas en la petición se encuentra desactivada";
    }
    else if (openpayErrorCode === 1009 && httpErrorCode === 413)
    {
      errorMessage = "El cuerpo de la petición es demasiado grande";
    }
    else if (openpayErrorCode === 1010 && httpErrorCode === 403)
    {
      errorMessage = "Se está utilizando la llave pública para hacer una llamada que requiere la llave privada, o bien, se está usando la llave privada desde JavaScript";
    }
    else if (openpayErrorCode === 1011 && httpErrorCode === 404)
    {
      errorMessage = "Se solicita un recurso que está marcado como eliminado";
    }
    else if (openpayErrorCode === 1012 && httpErrorCode === 412)
    {
      errorMessage = "El monto transacción está fuera de los límites permitidos";
    }
    else if (openpayErrorCode === 1013 && httpErrorCode === 412)
    {
      errorMessage = "La operación no está permitida para el recurso";
    }
    else if (openpayErrorCode === 1014 && httpErrorCode === 401)
    {
      errorMessage = "La cuenta está inactiva";
    }
    else if (openpayErrorCode === 1015 && httpErrorCode === 504)
    {
      errorMessage = "No se ha obtenido respuesta de la solicitud realizada al servicio";
    }
    else if (openpayErrorCode === 1016 && httpErrorCode === 409)
    {
      errorMessage = "El email del comercio ya ha sido procesado";
    }
    else if (openpayErrorCode === 1017 && httpErrorCode === 502)
    {
      errorMessage = "El gateway no se encuentra disponible en ese momento";
    }
    else if (openpayErrorCode === 1018 && httpErrorCode === 402)
    {
      errorMessage = "El número de intentos de cargo es mayor al permitido";
    }
    else if (openpayErrorCode === 1020 && httpErrorCode === 400)
    {
      errorMessage = "El número de dígitos decimales es inválido para esta moneda";
    }
    else if (openpayErrorCode === 1023 && httpErrorCode === 412)
    {
      errorMessage = "Se han terminado las transacciones incluidas en tu paquete. Para contratar otro paquete contácta a soporte@openpay.mx";
    }
    else if (openpayErrorCode === 1024 && httpErrorCode === 412)
    {
      errorMessage = "El monto de la transacción excede su límite de transacciones permitido por TPV";
    }
    else if (openpayErrorCode === 1025 && httpErrorCode === 412)
    {
      errorMessage = "Se han bloqueado las transacciones CoDi contratadas en tu plan";
    }
    else if (openpayErrorCode === 2001 && httpErrorCode === 409)
    {
      errorMessage = "La cuenta de banco con esta CLABE ya se encuentra registrada en el cliente";
    }
    else if (openpayErrorCode === 2003 && httpErrorCode === 409)
    {
      errorMessage = "El cliente con este identificador externo (External ID) ya existe";
    }
    else if (openpayErrorCode === 2004 && httpErrorCode === 422)
    {
      errorMessage = "El número de tarjeta es inválido";
    }
    else if (openpayErrorCode === 2005 && httpErrorCode === 400)
    {
      errorMessage = "La fecha de expiración de la tarjeta es anterior a la fecha actual";
    }
    else if (openpayErrorCode === 2006 && httpErrorCode === 400)
    {
      errorMessage = "El código de seguridad de la tarjeta (CVV2) no fue proporcionado";
    }
    else if (openpayErrorCode === 2007 && httpErrorCode === 412)
    {
      errorMessage = "El número de tarjeta es de prueba, solamente puede usarse en Sandbox";
    }
    else if (openpayErrorCode === 2008 && httpErrorCode === 412)
    {
      errorMessage = "La tarjeta no es válida para pago con puntos";
    }
    else if (openpayErrorCode === 2009 && httpErrorCode === 412)
    {
      errorMessage = "El código de seguridad de la tarjeta (CVV2) es inválido";
    }
    else if (openpayErrorCode === 2010 && httpErrorCode === 402)
    {
      errorMessage = "Auntentificación 3D Secure fallida";
    }
    else if (openpayErrorCode === 2011 && httpErrorCode === 422)
    {
      errorMessage = "Tipo de tarjeta no soportada";
    }
    else if (openpayErrorCode === 3001 && httpErrorCode === 402)
    {
      errorMessage = "La tarjeta fue declinada por el banco";
    }
    else if (openpayErrorCode === 3002 && httpErrorCode === 402)
    {
      errorMessage = "La tarjeta ha expirado";
    }
    else if (openpayErrorCode === 3003 && httpErrorCode === 402)
    {
      errorMessage = "La tarjeta no tiene fondos suficientes";
    }
    else if (openpayErrorCode === 3004 && httpErrorCode === 402)
    {
      errorMessage = "La tarjeta ha sido identificada como una tarjeta robada";
    }
    else if (openpayErrorCode === 3005 && httpErrorCode === 402)
    {
      errorMessage = "La tarjeta ha sido rechazada por el sistema antifraude. Rechazada por coincidir con registros en lista negra";
    }
    else if (openpayErrorCode === 3006 && httpErrorCode === 412)
    {
      errorMessage = "La operación no está permitida para este cliente o esta transacción";
    }
    else if (openpayErrorCode === 3009 && httpErrorCode === 402)
    {
      errorMessage = "La tarjeta fue reportada como perdida";
    }
    else if (openpayErrorCode === 3010 && httpErrorCode === 402)
    {
      errorMessage = "El banco ha restringido la tarjeta";
    }
    else if (openpayErrorCode === 3011 && httpErrorCode === 402)
    {
      errorMessage = "El banco ha solicitado que la tarjeta sea retenida. Contácte al banco";
    }
    else if (openpayErrorCode === 3012 && httpErrorCode === 412)
    {
      errorMessage = "Se requiere solicitar al banco autorización para realizar este pago";
    }
    else if (openpayErrorCode === 3201 && httpErrorCode === 412)
    {
      errorMessage = "Comercio no autorizado para procesar pago a meses sin intereses";
    }
    else if (openpayErrorCode === 3203 && httpErrorCode === 412)
    {
      errorMessage = "Promoción no válida para este tipo de tarjetas";
    }
    else if (openpayErrorCode === 3204 && httpErrorCode === 412)
    {
      errorMessage = "El monto de la transacción es menor al mínimo permitido para la promoción";
    }
    else if (openpayErrorCode === 3205 && httpErrorCode === 412)
    {
      errorMessage = "Promoción no permitida";
    }
    else if (openpayErrorCode === 4001 && httpErrorCode === 412)
    {
      errorMessage = "La cuenta de Openpay no tiene fondos suficientes";
    }
    else if (openpayErrorCode === 4002 && httpErrorCode === 412)
    {
      errorMessage = "La operación no puede ser completada hasta que sean pagadas las comisiones pendientes";
    }
    else if (openpayErrorCode === 6001 && httpErrorCode === 409)
    {
      errorMessage = "El webhook ya ha sido procesado";
    }
    else if (openpayErrorCode === 6002 && httpErrorCode === 412)
    {
      errorMessage = "No se ha podido conectar con el servicio de webhook";
    }
    else if (openpayErrorCode === 6003 && httpErrorCode === 502)
    {
      errorMessage = "El servicio respondió con errores";
    }
    return errorMessage;
  }
  private onUpgradeProduct(productId: number, orderDetailId:number)
  {
    const body: any =
    {
      "caseId": this.shoppingCartDataService.caseId,
      "productId": productId,
      "orderDetailId": orderDetailId
    };

    this.caseDataService.upgradeProduct(body)
      .subscribe((res) =>
      {
        this.setInfoAlert("Cambio de producto exitoso");
        this.shoppingCartDataService.onClearItems();
        this.isLoading = false;
        this.router.navigate(['ecommerce/compra-completada', { Code: this.purchaseCode }]);
      }, (error) =>
      {
        this.setDangerAlert(error.message);
      });
  }

  private addCasePurchasedOrders(caseId: number, orderId: number, orderDetailId?: number): void
  {
    let queryDef = new UrlQueryDef();

    const body: any =
    {
      "caseId": caseId,
      "orderId": orderId,
      "orderDetailId": orderDetailId
    };

    this.casePurchasedOrderDataService.insert(body, queryDef.getRequestConfig(true))
      .subscribe(response =>
      {
      }
      , (error) =>
      {
        this.setDangerAlert(error.message);
      });
  }

  protected onGetQueryDefForGetById()
  {
    let queryDef = new UrlQueryDef();
    queryDef.includes = "OrderDetail,OrderDetail.Product";
    return queryDef;
  }

  public doPendingPayment(purchaseCode)
  {
    this.purchaseCode = purchaseCode;
    let body ={
      id: this.orderId,
      paymentType: PaymentType.OpenPay,
      percentageAmountForMSIUsage: this.percentageForMSIUsage,
      financingMonths: this.getFinancingMonths()
    }
    this.orderDataService.updateOrderPaymentType(body)
    .subscribe(()=>
    {
      const body: any = {
        "id": this.orderId,
        "paymentStatus": OrderPaymentStatus.Completed,
      };
      this.orderDataService.updatePaymentStatus(body)
      .subscribe(()=>{
        this.isLoading = false;
        this.setSuccessAlert("Operación completada con éxito");
        this.router.navigate(['ecommerce/compra-completada', { Code: this.purchaseCode, orderId: this.orderId }]);
      })
     
    })
  }

  calculatePercentageForMSIUsage(){
    let percentageValue = 0;

    switch(this.paymentPlanSelected) {
      case PaymentPlan.SinglePayment:
        percentageValue = 0;
      break;

      case PaymentPlan.TwoMonths:
        percentageValue = (this.percentagsForMSIUsageSystemConfig.percentage3MSI??0)/100;
      break;

      case PaymentPlan.SixMonths:
        percentageValue = (this.percentagsForMSIUsageSystemConfig.percentage6MSI??0)/100;
      break;

      case PaymentPlan.NineMonths:
        percentageValue =  (this.percentagsForMSIUsageSystemConfig.percentage9MSI??0)/100;
      break;

      case PaymentPlan.TwelveMonths:
        percentageValue =  (this.percentagsForMSIUsageSystemConfig.percentage12MSI??0)/100;
      break;
    }

    let totalPercentage = +this.getTotalWOMSI * percentageValue;
    this.shoppingCartDataService.setPercentageForMSIUsage(+totalPercentage.toFixed(2));
  }

  getFinancingMonths(): number{
    let percentageValue = 0;

    switch(this.paymentPlanSelected) {
      case PaymentPlan.SinglePayment:
        percentageValue = 0;
      break;

      case PaymentPlan.TwoMonths:
        percentageValue = 3;
      break;

      case PaymentPlan.SixMonths:
        percentageValue = 6;
      break;

      case PaymentPlan.NineMonths:
        percentageValue =  9;
      break;

      case PaymentPlan.TwelveMonths:
        percentageValue =  12;
      break;
    }

    return percentageValue;
  }
}
